import { motion } from "framer-motion";
import { ArrowUpRight, Calendar, Sparkles } from "lucide-react";
import HeroScene from "@/components/sections/HeroScene";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-[#050505] text-white"
    >
      {/* 3D Canvas background */}
      <div className="absolute inset-0 z-0">
        <HeroScene />
      </div>

      {/* Subtle grid overlay */}
      <div className="absolute inset-0 z-[1] grid-bg pointer-events-none opacity-50" />

      {/* Vignette */}
      <div className="absolute inset-0 z-[2] pointer-events-none bg-[radial-gradient(ellipse_at_center,transparent_30%,#050505_85%)]" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-32 md:pt-40 pb-24 min-h-screen flex flex-col justify-between">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="md:col-span-12"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/15 bg-white/5 backdrop-blur-md text-xs tracking-[0.2em] uppercase text-white/70 mb-8">
              <Sparkles className="w-3 h-3" /> Custom Business Operating System
            </div>

            <h1
              data-testid="hero-headline"
              className="font-display text-5xl sm:text-6xl lg:text-8xl font-light tracking-tighter leading-[0.95] max-w-5xl"
            >
              Your Business.
              <br />
              Your Workflow.
              <br />
              <span className="text-white/40">Your CRM.</span>
            </h1>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.4, ease: "easeOut" }}
          className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mt-12 md:mt-0"
        >
          <p className="md:col-span-5 text-base md:text-lg text-white/60 font-light leading-relaxed max-w-md">
            We do not sell a generic CRM. We build a custom AI-powered operating
            system around the way <span className="text-white">your business actually works.</span>
          </p>

          <div className="md:col-span-7 flex flex-wrap gap-3 md:justify-end">
            <a
              href="#contact"
              data-testid="hero-cta-book-demo"
              className="group inline-flex items-center gap-2 bg-white text-black text-sm font-medium px-6 py-3.5 rounded-full hover:bg-white/90 active:scale-95 transition-all duration-300"
            >
              <Calendar className="w-4 h-4" /> Book Demo
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              href="#contact"
              data-testid="hero-cta-custom-solution"
              className="group inline-flex items-center gap-2 border border-white/20 text-white text-sm font-medium px-6 py-3.5 rounded-full hover:bg-white/5 active:scale-95 transition-all duration-300"
            >
              Get Custom Solution
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              href="#contact"
              data-testid="hero-cta-consultation"
              className="group inline-flex items-center gap-2 text-white/70 text-sm font-medium px-6 py-3.5 rounded-full hover:text-white transition-all duration-300"
            >
              Schedule Consultation →
            </a>
          </div>
        </motion.div>
      </div>

      {/* Bottom marquee hint */}
      <div className="absolute bottom-6 left-0 right-0 z-10 flex justify-center pointer-events-none">
        <span className="text-[10px] tracking-[0.4em] uppercase text-white/40">scroll</span>
      </div>
    </section>
  );
}
